// Kiosk analytics — fires events to backend for ops dashboard
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

let _centerId = null;
let _guestId = null;
let _flow = null;

// Set context once per flow (called from KioskFlow or sub-components)
export function setKioskContext({ centerId, guestId, flow }) {
  if (centerId !== undefined) _centerId = centerId;
  if (guestId !== undefined) _guestId = guestId;
  if (flow !== undefined) _flow = flow;
}

export function clearKioskContext() {
  _centerId = null;
  _guestId = null;
  _flow = null;
}

// Fire a single event (non-blocking, fire-and-forget)
export function kev(screen, event, metadata) {
  if (!_centerId || !_flow) return;
  const body = {
    centerId: _centerId,
    guestId: _guestId || null,
    flow: _flow,
    screen,
    event,
    metadata: metadata || undefined,
  };
  fetch(`${API_URL}/api/kiosk/event`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  }).catch(() => {}); // silently ignore failures
}
